import { useCallback, useRef, useState } from "react";

const useInViewOnce = () => {
  const [inView, setInView] = useState(false);
  const observerRef = useRef(null);

  const setRef = useCallback(
    (node) => {
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
      if (node && !inView) {
        const observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.disconnect();
          }
        });
        observerRef.current = observer;
        observer.observe(node);
      }
    },
    [inView]
  );

  return [setRef, inView];
};

export default useInViewOnce;
